import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { isAsciiDigit3p3aq858xklh as isAsciiDigit } from '../util.mjs';
import {
  substringiqarkczpya5m as substring,
  substring3saq8ornu0luv as substring_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { ConstantNumberConsumer1fkn3mtvfbopz as ConstantNumberConsumer } from './parser/NumberConsumer.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  NumberSpanParserOperation3qyp02c4km7yu as NumberSpanParserOperation,
  PlainStringParserOperation3o6zmwb0f0e6n as PlainStringParserOperation,
  SignParserj94qlnys16wg as SignParser,
  UnconditionalModification151pp4lqfue9i as UnconditionalModification,
} from './parser/ParserOperation.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_lastIndexld83bqhfgcdd as get_lastIndex } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOf1jh22dvmctj1r as listOf_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  ParserStructure2cqp7gjft5io4 as ParserStructure,
  concat2z827ubu7ap26 as concat,
} from './parser/Parser.mjs';
import { ConstantStringFormatterStructure25vvm6os5tq8f as ConstantStringFormatterStructure } from './formatter/FormatterOperation.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  distinct10qe1scfdvu5k as distinct,
  joinToString1cxrrlmo0chqs as joinToString,
  singleo93pzdgfc557 as single,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  SignedFormatter14cujr8xyyuqw as SignedFormatter,
  ConditionalFormatter2qfqdnibwbifo as ConditionalFormatter,
  ConcatenatedFormattergumn65iplrh1 as ConcatenatedFormatter,
} from './formatter/Formatter.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Accessor$getter$ref5gz1lb7u1i2c as Accessor$getter$ref } from './FieldSpec.mjs';
import {
  ComparisonPredicate21wq2zjdls3fu as ComparisonPredicate,
  conjunctionPredicate3qd2h4fxtw47e as conjunctionPredicate,
  Predicate$test$ref1gcv0vzg86rab as Predicate$test$ref,
  Truth_instance578180c81czc as Truth_instance,
  Truth$test$ref26ex5sva906mv as Truth$test$ref,
  Truth1p2zb9jq6ku60 as Truth,
} from './Predicate.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CachedFormatStructureClass;
function CachedFormatStructure() {
  if (CachedFormatStructureClass === VOID) {
    class $ extends ConcatenatedFormatStructure() {
      constructor(formats) {
        super(formats);
        this.cachedFormatter_1 = super.formatter_tykoui_k$();
        this.cachedParser_1 = super.parser_ggn3z5_k$();
      }
      formatter_tykoui_k$() {
        return this.cachedFormatter_1;
      }
      parser_ggn3z5_k$() {
        return this.cachedParser_1;
      }
    }
    initMetadataForClass($, 'CachedFormatStructure');
    CachedFormatStructureClass = $;
  }
  return CachedFormatStructureClass;
}
var BasicFormatStructureClass;
function BasicFormatStructure() {
  if (BasicFormatStructureClass === VOID) {
    class $ {
      constructor(directive) {
        this.directive_1 = directive;
      }
      toString() {
        return 'BasicFormatStructure(' + toString(this.directive_1) + ')';
      }
      equals(other) {
        var tmp;
        if (other instanceof BasicFormatStructure()) {
          tmp = equals(this.directive_1, other.directive_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.directive_1);
      }
      parser_ggn3z5_k$() {
        return this.directive_1.parser_ggn3z5_k$();
      }
      formatter_tykoui_k$() {
        return this.directive_1.formatter_tykoui_k$();
      }
    }
    initMetadataForClass($, 'BasicFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure()]);
    BasicFormatStructureClass = $;
  }
  return BasicFormatStructureClass;
}
var ConstantFormatStructureClass;
function ConstantFormatStructure() {
  if (ConstantFormatStructureClass === VOID) {
    class $ {
      constructor(string) {
        this.string_1 = string;
      }
      toString() {
        return 'ConstantFormatStructure(' + this.string_1 + ')';
      }
      equals(other) {
        var tmp;
        if (other instanceof ConstantFormatStructure()) {
          tmp = this.string_1 === other.string_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return getStringHashCode(this.string_1);
      }
      parser_ggn3z5_k$() {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        var this_0 = this.string_1;
        if (charSequenceLength(this_0) === 0) {
          tmp = emptyList();
        } else {
          // Inline function 'kotlin.collections.buildList' call
          // Inline function 'kotlin.collections.buildListInternal' call
          // Inline function 'kotlin.apply' call
          var this_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var tmp_0;
          if (isAsciiDigit(charCodeAt(this.string_1, 0))) {
            var tmp0 = this.string_1;
            var tmp$ret$5;
            $l$block: {
              // Inline function 'kotlin.text.takeWhile' call
              var inductionVariable = 0;
              var last = tmp0.length;
              if (inductionVariable < last)
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var it = charCodeAt(tmp0, index);
                  if (!isAsciiDigit(it)) {
                    tmp$ret$5 = substring(tmp0, 0, index);
                    break $l$block;
                  }
                }
                 while (inductionVariable < last);
              tmp$ret$5 = tmp0;
            }
            this_1.add_utx5q5_k$(new (NumberSpanParserOperation())(listOf(new (ConstantNumberConsumer())(tmp$ret$5))));
            var tmp0_0 = this.string_1;
            var tmp$ret$7;
            $l$block_0: {
              // Inline function 'kotlin.text.dropWhile' call
              var inductionVariable_0 = 0;
              var last_0 = charSequenceLength(tmp0_0) - 1 | 0;
              if (inductionVariable_0 <= last_0)
                do {
                  var index_0 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var it_0 = charCodeAt(tmp0_0, index_0);
                  if (!isAsciiDigit(it_0)) {
                    tmp$ret$7 = substring_0(tmp0_0, index_0);
                    break $l$block_0;
                  }
                }
                 while (inductionVariable_0 <= last_0);
              tmp$ret$7 = '';
            }
            tmp_0 = tmp$ret$7;
          } else {
            tmp_0 = this.string_1;
          }
          var suffix = tmp_0;
          // Inline function 'kotlin.text.isNotEmpty' call
          if (charSequenceLength(suffix) > 0) {
            if (isAsciiDigit(charCodeAt(suffix, suffix.length - 1 | 0))) {
              var tmp$ret$10;
              $l$block_1: {
                // Inline function 'kotlin.text.dropLastWhile' call
                var inductionVariable_1 = get_lastIndex(suffix);
                if (0 <= inductionVariable_1)
                  do {
                    var index_1 = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + -1 | 0;
                    var it_1 = charCodeAt(suffix, index_1);
                    if (!isAsciiDigit(it_1)) {
                      tmp$ret$10 = substring(suffix, 0, index_1 + 1 | 0);
                      break $l$block_1;
                    }
                  }
                   while (0 <= inductionVariable_1);
                tmp$ret$10 = '';
              }
              this_1.add_utx5q5_k$(new (PlainStringParserOperation())(tmp$ret$10));
              var tmp$ret$12;
              $l$block_2: {
                // Inline function 'kotlin.text.takeLastWhile' call
                var inductionVariable_2 = get_lastIndex(suffix);
                if (0 <= inductionVariable_2)
                  do {
                    var index_2 = inductionVariable_2;
                    inductionVariable_2 = inductionVariable_2 + -1 | 0;
                    var it_2 = charCodeAt(suffix, index_2);
                    if (!isAsciiDigit(it_2)) {
                      tmp$ret$12 = substring_0(suffix, index_2 + 1 | 0);
                      break $l$block_2;
                    }
                  }
                   while (0 <= inductionVariable_2);
                tmp$ret$12 = suffix;
              }
              this_1.add_utx5q5_k$(new (NumberSpanParserOperation())(listOf(new (ConstantNumberConsumer())(tmp$ret$12))));
            } else {
              this_1.add_utx5q5_k$(new (PlainStringParserOperation())(suffix));
            }
          }
          tmp = this_1.build_nmwvly_k$();
        }
        return new (ParserStructure())(tmp, emptyList());
      }
      formatter_tykoui_k$() {
        return new (ConstantStringFormatterStructure())(this.string_1);
      }
    }
    initMetadataForClass($, 'ConstantFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure()]);
    ConstantFormatStructureClass = $;
  }
  return ConstantFormatStructureClass;
}
function formatter$checkIfAllNegative(this$0, value) {
  var seenNonZero = false;
  var _iterator__ex2g4s = this$0.fieldSigns_1.iterator_jk1svi_k$();
  $l$loop: while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var check = _iterator__ex2g4s.next_20eer_k$();
    if (check.get_isNegative_i24zqw_k$().getter_8mvnhr_k$(value) === true)
      seenNonZero = true;
    else if (check.isZero_yccjay_k$(value))
      continue $l$loop;
    else
      return false;
  }
  return seenNonZero;
}
function SignedFormatStructure$formatter$checkIfAllNegative$ref(this$0) {
  return constructCallableReference((p0) => formatter$checkIfAllNegative(this$0, p0), 1, 0, 62, 'checkIfAllNegative', [this$0]);
}
var SignedFormatStructureClass;
function SignedFormatStructure() {
  if (SignedFormatStructureClass === VOID) {
    class $ {
      constructor(format, withPlusSign) {
        this.format_1 = format;
        this.withPlusSign_1 = withPlusSign;
        var tmp = this;
        // Inline function 'kotlin.collections.mapNotNull' call
        var tmp0 = basicFormats(this.format_1);
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          var tmp0_safe_receiver = element.get_field_irdnf5_k$().get_sign_woubd2_k$();
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination.add_utx5q5_k$(tmp0_safe_receiver);
          }
        }
        tmp.fieldSigns_1 = toSet(destination);
        // Inline function 'kotlin.collections.isNotEmpty' call
        // Inline function 'kotlin.require' call
        if (!!this.fieldSigns_1.isEmpty_y1axqb_k$()) {
          var message = 'Signed format must contain at least one field with a sign';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
      }
      toString() {
        return 'SignedFormatStructure(' + toString(this.format_1) + ')';
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (other instanceof SignedFormatStructure()) {
          tmp_0 = equals(this.format_1, other.format_1);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.withPlusSign_1 === other.withPlusSign_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return imul(31, hashCode(this.format_1)) + getBooleanHashCode(this.withPlusSign_1) | 0;
      }
      parser_ggn3z5_k$() {
        return concat(listOf_0([new (ParserStructure())(listOf(new (SignParser())((value, isNegative) => {
          var _iterator__ex2g4s = this.fieldSigns_1.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var field = _iterator__ex2g4s.next_20eer_k$();
            var wasNegative = field.get_isNegative_i24zqw_k$().getter_8mvnhr_k$(value) === true;
            field.get_isNegative_i24zqw_k$().trySetWithoutReassigning_itlg4a_k$(value, !(isNegative === wasNegative));
          }
          return Unit_instance;
        }, this.withPlusSign_1, 'sign for ' + toString(this.fieldSigns_1))), emptyList()), this.format_1.parser_ggn3z5_k$()]));
      }
      formatter_tykoui_k$() {
        var innerFormat = this.format_1.formatter_tykoui_k$();
        return new (SignedFormatter())(innerFormat, SignedFormatStructure$formatter$checkIfAllNegative$ref(this), this.withPlusSign_1);
      }
    }
    initMetadataForClass($, 'SignedFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure()]);
    SignedFormatStructureClass = $;
  }
  return SignedFormatStructureClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      fromField_3ctjbq_k$(field) {
        var default_0 = field.get_defaultValue_6cv1mv_k$();
        // Inline function 'kotlin.require' call
        if (!!(default_0 == null)) {
          var message = "The field '" + field.get_name_woqyms_k$() + "' does not define a default value";
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        return new (PropertyWithDefault())(field.get_accessor_3q8qa8_k$(), default_0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var PropertyWithDefaultClass;
function PropertyWithDefault() {
  if (PropertyWithDefaultClass === VOID) {
    class $ {
      constructor(accessor, defaultValue) {
        this.accessor_1 = accessor;
        this.defaultValue_1 = defaultValue;
      }
    }
    initMetadataForClass($, 'PropertyWithDefault');
    PropertyWithDefaultClass = $;
  }
  return PropertyWithDefaultClass;
}
var OptionalFormatStructureClass;
function OptionalFormatStructure() {
  if (OptionalFormatStructureClass === VOID) {
    class $ {
      constructor(onZero, format) {
        this.onZero_1 = onZero;
        this.format_1 = format;
        var tmp = this;
        // Inline function 'kotlin.collections.map' call
        var this_0 = basicFormats(this.format_1);
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$2 = item.get_field_irdnf5_k$();
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        // Inline function 'kotlin.collections.map' call
        var this_1 = distinct(destination);
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_1, 10));
        var _iterator__ex2g4s_0 = this_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var item_0 = _iterator__ex2g4s_0.next_20eer_k$();
          var tmp$ret$5 = Companion_instance.fromField_3ctjbq_k$(item_0);
          destination_0.add_utx5q5_k$(tmp$ret$5);
        }
        tmp.fields_1 = destination_0;
      }
      toString() {
        return 'Optional(' + this.onZero_1 + ', ' + toString(this.format_1) + ')';
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (other instanceof OptionalFormatStructure()) {
          tmp_0 = this.onZero_1 === other.onZero_1;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals(this.format_1, other.format_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return imul(31, getStringHashCode(this.onZero_1)) + hashCode(this.format_1) | 0;
      }
      parser_ggn3z5_k$() {
        var tmp = emptyList();
        var tmp_0 = this.format_1.parser_ggn3z5_k$();
        var tmp_1 = (new (ConstantFormatStructure())(this.onZero_1)).parser_ggn3z5_k$();
        var tmp_2;
        if (this.fields_1.isEmpty_y1axqb_k$()) {
          tmp_2 = emptyList();
        } else {
          tmp_2 = listOf(new (UnconditionalModification())((it) => {
            var _iterator__ex2g4s = this.fields_1.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var field = _iterator__ex2g4s.next_20eer_k$();
              // Inline function 'kotlinx.datetime.internal.format.PropertyWithDefault.assignDefault' call
              field.accessor_1.trySetWithoutReassigning_itlg4a_k$(it, field.defaultValue_1);
            }
            return Unit_instance;
          }));
        }
        return new (ParserStructure())(tmp, listOf_0([tmp_0, concat(listOf_0([tmp_1, new (ParserStructure())(tmp_2, emptyList())]))]));
      }
      formatter_tykoui_k$() {
        var formatter = this.format_1.formatter_tykoui_k$();
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.fields_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlinx.datetime.internal.format.PropertyWithDefault.isDefaultComparisonPredicate' call
          var tmp$ret$2 = new (ComparisonPredicate())(item.defaultValue_1, Accessor$getter$ref(item.accessor_1));
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        var predicate = conjunctionPredicate(destination);
        var tmp;
        if (predicate instanceof Truth()) {
          tmp = new (ConstantStringFormatterStructure())(this.onZero_1);
        } else {
          var tmp_0 = to(Predicate$test$ref(predicate), new (ConstantStringFormatterStructure())(this.onZero_1));
          tmp = new (ConditionalFormatter())(listOf_0([tmp_0, to(Truth$test$ref(Truth_instance), formatter)]));
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'OptionalFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure()]);
    OptionalFormatStructureClass = $;
  }
  return OptionalFormatStructureClass;
}
var AlternativesParsingFormatStructureClass;
function AlternativesParsingFormatStructure() {
  if (AlternativesParsingFormatStructureClass === VOID) {
    class $ {
      constructor(mainFormat, formats) {
        this.mainFormat_1 = mainFormat;
        this.formats_1 = formats;
      }
      toString() {
        return 'AlternativesParsing(' + toString(this.formats_1) + ')';
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (other instanceof AlternativesParsingFormatStructure()) {
          tmp_0 = equals(this.mainFormat_1, other.mainFormat_1);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals(this.formats_1, other.formats_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return imul(31, hashCode(this.mainFormat_1)) + hashCode(this.formats_1) | 0;
      }
      parser_ggn3z5_k$() {
        var tmp = emptyList();
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this_0.add_utx5q5_k$(this.mainFormat_1.parser_ggn3z5_k$());
        var _iterator__ex2g4s = this.formats_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var format = _iterator__ex2g4s.next_20eer_k$();
          this_0.add_utx5q5_k$(format.parser_ggn3z5_k$());
        }
        var tmp$ret$0 = this_0.build_nmwvly_k$();
        return new (ParserStructure())(tmp, tmp$ret$0);
      }
      formatter_tykoui_k$() {
        return this.mainFormat_1.formatter_tykoui_k$();
      }
    }
    initMetadataForClass($, 'AlternativesParsingFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure()]);
    AlternativesParsingFormatStructureClass = $;
  }
  return AlternativesParsingFormatStructureClass;
}
var ConcatenatedFormatStructureClass;
function ConcatenatedFormatStructure() {
  if (ConcatenatedFormatStructureClass === VOID) {
    class $ {
      constructor(formats) {
        this.formats_1 = formats;
      }
      toString() {
        return 'ConcatenatedFormatStructure(' + joinToString(this.formats_1, ', ') + ')';
      }
      equals(other) {
        var tmp;
        if (other instanceof ConcatenatedFormatStructure()) {
          tmp = equals(this.formats_1, other.formats_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.formats_1);
      }
      parser_ggn3z5_k$() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.formats_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$2 = item.parser_ggn3z5_k$();
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        return concat(destination);
      }
      formatter_tykoui_k$() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.formats_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$2 = item.formatter_tykoui_k$();
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        var formatters = destination;
        var tmp;
        if (formatters.get_size_woubt6_k$() === 1) {
          tmp = single(formatters);
        } else {
          tmp = new (ConcatenatedFormatter())(formatters);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'ConcatenatedFormatStructure');
    ConcatenatedFormatStructureClass = $;
  }
  return ConcatenatedFormatStructureClass;
}
var NonConcatenatedFormatStructureClass;
function NonConcatenatedFormatStructure() {
  if (NonConcatenatedFormatStructureClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'NonConcatenatedFormatStructure');
    NonConcatenatedFormatStructureClass = $;
  }
  return NonConcatenatedFormatStructureClass;
}
function basicFormats(format) {
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  basicFormats$rec(this_0, format);
  return this_0.build_nmwvly_k$();
}
function basicFormats$rec($this_buildList, format) {
  if (format instanceof BasicFormatStructure())
    $this_buildList.add_utx5q5_k$(format.directive_1);
  else {
    if (format instanceof ConcatenatedFormatStructure()) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = format.formats_1.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        basicFormats$rec($this_buildList, element);
      }
    } else {
      if (!(format instanceof ConstantFormatStructure())) {
        if (format instanceof SignedFormatStructure()) {
          basicFormats$rec($this_buildList, format.format_1);
        } else {
          if (format instanceof AlternativesParsingFormatStructure()) {
            basicFormats$rec($this_buildList, format.mainFormat_1);
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s_0 = format.formats_1.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
              var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
              basicFormats$rec($this_buildList, element_0);
            }
          } else {
            if (format instanceof OptionalFormatStructure()) {
              basicFormats$rec($this_buildList, format.format_1);
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
  }
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  AlternativesParsingFormatStructure as AlternativesParsingFormatStructure1jbxrbmj8ihe6,
  BasicFormatStructure as BasicFormatStructure1rp1tyv3u2fjw,
  CachedFormatStructure as CachedFormatStructurec5vu2vku3yjz,
  ConcatenatedFormatStructure as ConcatenatedFormatStructure27s7lx6ixzw2f,
  ConstantFormatStructure as ConstantFormatStructure2ckhnu4xssh81,
  NonConcatenatedFormatStructure as NonConcatenatedFormatStructure1tep5eavrzcwp,
  OptionalFormatStructure as OptionalFormatStructure1lur7h5l20ekc,
  SignedFormatStructure as SignedFormatStructure3e3cmtnnik1yf,
};
//endregion

//# sourceMappingURL=FormatStructure.mjs.map
